var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNotePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18V5.58885C14.5 4.73163 14.5 4.30302 14.6805 4.04489C14.8382 3.81949 15.0817 3.66897 15.3538 3.62877C15.6655 3.58273 16.0488 3.77441 16.8155 4.15777L20.5 6M14.5 18C14.5 19.6569 13.1569 21 11.5 21C9.84315 21 8.5 19.6569 8.5 18C8.5 16.3431 9.84315 15 11.5 15C13.1569 15 14.5 16.3431 14.5 18ZM6.5 10V4M3.5 7H9.5",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNotePlus);
export default __webpack_public_path__ + "static/media/music-note-plus.de12ae0f50cfa79ed662f5f902f61b89.svg";
export { ForwardRef as ReactComponent };